
/**
 * Front-end Scripts - Rippling Job Board
 */

(function ($) {
  $(document).ready(function () {

    // Main Wrapper
    const $jsJobItems = $('#js-job-items');

    // Job Boards
    const $chem = $('#job-board-group-chemistry-careers');
    const $reactDigital = $('#job-board-group-react-digital');
    const $ttp = $('#job-board-group-test-tube-productions');
    const $cultura = $('#job-board-group-cultura');
    const $futureExperiments = $('#job-board-group-future-experiments');

    // Filter Inputs
    const $filerSearchInput = $('#jobs-filter-search');
    const $filterSelectDept = $('#jobs-filter-department');
    const $filterSelectLocation = $('#jobs-filter-location');
    const $filterReset = $('.jobs-filter-reset-button');

    // Init Results Total
    let resultsTotal = $jsJobItems.find( 'li[data-job-uuid]:not(:hidden)' ).length;

    // Init Lists
    let jobListChem;
    let jobListReact;
    let jobListTt;
    let jobListCultura;
    let jobListFuture;

    // `list.js` Args
    const listArgs = {
      listClass: 'js-job-list',
      valueNames: [
        'js-filter-name',
        'js-filter-department',
        'js-filter-location',
      ],
    };

    // Setup a List for each board
    if ( $chem.length ) {
      jobListChem = new List( 'job-board-group-chemistry-careers', listArgs );
    }
    if ( $reactDigital.length ) {
      jobListReact = new List( 'job-board-group-react-digital', listArgs );
    }
    if ( $ttp.length ) {
      jobListTt = new List( 'job-board-group-test-tube-productions', listArgs );
    }
    if ( $cultura.length ) {
      jobListCultura = new List( 'job-board-group-cultura', listArgs );
    }
    if ( $futureExperiments.length ) {
      jobListFuture = new List( 'job-board-group-future-experiments', listArgs );
    }

    // Search all Lists using the same search input
    $filerSearchInput.on('keyup', function () {
      const thisValue = $(this).val();

      if ( jobListChem !== null ) {
        jobListChem.search( thisValue );
      }
      if ( jobListReact !== null ) {
        jobListReact.search( thisValue );
      }
      if ( jobListTt !== null ) {
        jobListTt.search( thisValue );
      }
      if ( jobListCultura !== null ) {
        jobListCultura.search( thisValue );
      }
      if ( jobListFuture !== null ) {
        jobListFuture.search( thisValue );
      }

      // Update Results Count
      resultsTotal = $jsJobItems.find( 'li[data-job-uuid]:not(:hidden)' ).length;
    });

    // Reset Button
    $filterReset.on('click', function () {
      // Clear input vals & reset dropdown filters
      $filerSearchInput.val( '' );
      $filterSelectDept.val( '' ).trigger( 'change' );
      $filterSelectLocation.val( '' ).trigger( 'change' );

      // Clear `list.js` filter data
      if ( jobListChem !== null ) {
        jobListChem.search();
      }
      if ( jobListFuture !== null ) {
        jobListReact.search();
      }
      if ( jobListTt !== null ) {
        jobListTt.search();
      }
      if ( jobListCultura !== null ) {
        jobListCultura.search();
      }
      if ( jobListFuture !== null ) {
        jobListFuture.search();
      }

      // Update Results Count
      resultsTotal = $jsJobItems.find( 'li[data-job-uuid]:not(:hidden)' ).length;
      return false;
    });


    /**
     * Quick n dirty select filters
     */

    const $jobs = $('li[data-job-uuid]');

    // Department - Select Filter
    $filterSelectDept.on('change', function (e) {
      e.preventDefault();
      const $this = $(this);
      const filterValue = $this.val();
      const siblingValue = $('#jobs-filter-location').val();

      // Prep for matches
      $jobs.prop( 'hidden', true );

      // Match Both Filters
      if ( filterValue !== ''
        && siblingValue !== '' ) {
        $jobs
          .filter( '[data-job-department-id="' + filterValue + '"]' )
          .filter( '[data-job-location-id="' + siblingValue + '"]' )
          .prop( 'hidden', false );

      // Match this filter
      } else if ( filterValue !== '' ) {
        $jobs.filter( '[data-job-department-id="' + filterValue + '"]' )
          .prop( 'hidden', false );

      // Match Sibling - Keeps active sibling filter applied
      } else if ( siblingValue !== '' ) {
        $jobs
          .filter( '[data-job-location-id="' + siblingValue + '"]' )
          .prop( 'hidden', false );

      // No Active Filter
      } else {
        $jobs.prop( 'hidden', false );
      }

      // Update Results Count
      resultsTotal = $jsJobItems.find( 'li[data-job-uuid]:not(:hidden)' ).length;
    });

    // Location - Select Filter
    $filterSelectLocation.on('change', function (e) {
      e.preventDefault();
      const $this = $(this);
      const filterValue = $this.val();
      const siblingValue = $('#jobs-filter-department').val();

      // Prep for matches
      $jobs.prop( 'hidden', true );

      // Match Both Filters
      if ( filterValue !== ''
        && siblingValue !== '' ) {
        $jobs
          .filter( '[data-job-location-id="' + filterValue + '"]' )
          .filter( '[data-job-department-id="' + siblingValue + '"]' )
          .prop( 'hidden', false );

      // Match this filter
      } else if ( filterValue !== '' ) {
        $jobs.filter( '[data-job-location-id="' + filterValue + '"]' )
          .prop( 'hidden', false );

      // Match Sibling - Keeps active sibling filter applied
      } else if ( siblingValue !== '' ) {
        $jobs
          .filter( '[data-job-department-id="' + siblingValue + '"]' )
          .prop( 'hidden', false );

      // No Active Filter
      } else {
        $jobs.prop( 'hidden', false );
      }

      // Update Results Count
      resultsTotal = $jsJobItems.find( 'li[data-job-uuid]:not(:hidden)' ).length;
    });

  });
})(jQuery);
